import imgInprox from '../../../../images/viluu/email-providers/inprox.png';
import imgGmx from '../../../../images/viluu/email-providers/gmx.png';
import imgHotmail from '../../../../images/viluu/email-providers/hotmail.png';
import imgWebDe from '../../../../images/viluu/email-providers/webde.png';
import imgFreenet from '../../../../images/viluu/email-providers/freenet.png';
import imgGmail from '../../../../images/viluu/email-providers/gmail.png';
import imgIcloud from '../../../../images/viluu/email-providers/icloud.png';
import imgYahoo from '../../../../images/viluu/email-providers/yahoo.png';

const domainsLinks = {
  'inprox.pl': {
    name: 'inprox',
    url: 'https://poczta.inprox.pl',
    image: imgInprox,
  },
  'gmx.de': {
    name: 'gmx.net',
    url: 'https://www.gmx.net/',
    image: imgGmx,
  },
  'hotmail.de': {
    name: 'hotmail',
    url: 'https://login.live.com/',
    image: imgHotmail,
  },
  'web.de': {
    name: 'web.de',
    url: 'https://web.de/',
    image: imgWebDe,
  },
  'freenet.de': {
    name: 'freenet.de',
    url: 'https://www.freenet.de/index.html',
    image: imgFreenet,
  },
  'gmail.com': {
    name: 'gmail',
    url: 'https://accounts.google.com/ServiceLogin?service=mail',
    image: imgGmail,
  },
  'icloud.com': {
    name: 'icloud',
    url: 'https://www.icloud.com/mail',
    image: imgIcloud,
  },
  'yahoo.com': {
    name: 'yahoo',
    url: 'https://login.yahoo.com',
    image: imgYahoo,
  },
  'googlemail.com': {
    name: 'gmail',
    url: 'https://accounts.google.com/ServiceLogin?service=mail',
    image: imgGmail,
  },
};

export default {
  props: {},
  data() {
    return {};
  },
  computed: {
    mailWebDomain: function () {
      return ('' + this.form.email).toLowerCase().split('@')[1];
    },
    mailWebObject: function () {
      const domain = this.mailWebDomain;
      return domainsLinks[domain] || (domain ? { name: domain, url: 'https://' + domain } : '');
    },
    allDomainsLinks: function () {
      return domainsLinks;
    },
  },
  watch: {},
  methods: {},
  mounted() {
  },
  activated() {
  },
  deactivated() {
  }
};
